"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tollCollectParkingStatusSchema = void 0;
const zod_1 = require("zod");
const rest_area_1 = require("./rest-area");
// An explicit z.ZodObject<Shape> annotation truncates the generated .d.ts to a partial
// generic; consumers with strictNullChecks:false (e.g. routing-functions) then recompute
// Output/Input and every field turns optional. Leave this to inference so the compiled
// .d.ts bakes in the full, consumer-proof type.
exports.tollCollectParkingStatusSchema = zod_1.z.object({
    id: zod_1.z.string(),
    version: zod_1.z.string(),
    statusOriginTime: zod_1.z.string(),
    siteStatus: rest_area_1.SiteAvailabilityStatusSchema,
    openingStatus: rest_area_1.SiteOpeningStatusSchema,
    numberOfVehicles: zod_1.z.number().optional(),
    occupancyRate: zod_1.z.number().optional(),
});
//# sourceMappingURL=tollcollect.js.map